<script>
import { Pie } from 'vue-chartjs'

export default {
  extends: Pie,
  props: {
    summary: Object,
  },
  computed: {
    datalist() {
      return Object.values(this.summary.resourceType.breakdown);
    },
    titlelist() {
      return Object.keys(this.summary.resourceType.breakdown);
    },
  },
  mounted() {
    this.addPlugin({
      beforeRender: function (chart) {
        if (chart.config.options.showAllTooltips) {
          chart.pluginTooltips = [];
          chart.config.data.datasets.forEach(function (dataset, i) {
            chart.getDatasetMeta(i).data.forEach(function (sector, j) {
              chart.pluginTooltips.push(new Chart.Tooltip({
                _chart: chart.chart,
                _chartInstance: chart,
                _data: chart.data,
                _options: chart.options.tooltips,
                _active: [sector]
              }, chart));
            });
          });
          chart.options.tooltips.enabled = false;
        }
      },
      afterDraw: function (chart, easing) {
        if (chart.config.options.showAllTooltips) {
          if (!chart.allTooltipsOnce) {
            if (easing !== 1)
            return;
            chart.allTooltipsOnce = true;
          }

          chart.options.tooltips.enabled = true;
          Chart.helpers.each(chart.pluginTooltips, function (tooltip) {
            tooltip.initialize();
            tooltip.update();
            tooltip.transition(easing).draw();
          });
          chart.options.tooltips.enabled = false;
        }
      }
    });

    this.renderChart(
      {
        labels: this.titlelist,
        datasets: [
          {
            label: this.titlelist,
            backgroundColor: ['#ff8c00', '#f87979', '#da70d6', '#3cb371', '#87cefa'],
            data: this.datalist
          }
        ],
      },
      {
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              var label = data.datasets[tooltipItem.datasetIndex].label;
              var d = data.datasets[tooltipItem.datasetIndex].data;

              var total = Number(0);
              d.forEach(function(q){
                total = total + q
              })

              var labelText = label[tooltipItem.index];
              labelText += Math.round(d[tooltipItem.index] / total * 100) + '%' ;
              return labelText;
            }
          },
        },
        responsive: true,
        maintainAspectRatio: false,
        showAllTooltips: true,
      }
    );
  }
}
</script>